import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ae64b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "request-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "request-form__title" }, "Записаться на проект", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "request-form__text" }, "Просто заполните форму ниже, мы перезвоним", -1))
const _hoisted_4 = { class: "request-form__inner" }
const _hoisted_5 = {
  class: "request-form__agreement",
  style: {"display":"flex","align-items":"flex-start","gap":"8px","cursor":"pointer"}
}
const _hoisted_6 = {
  class: "request-form__annotation",
  style: {"user-select":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_AppInput, {
        modelValue: _ctx.form.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
        placeholder: "Имя",
        required: "",
        error: _ctx.validationErrors.name
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_AppInput, {
        modelValue: _ctx.form.phone,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.phone) = $event)),
        placeholder: "Телефон",
        required: "",
        error: _ctx.validationErrors.phone
      }, null, 8, ["modelValue", "error"]),
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agreement) = $event)),
          style: {"margin-top":"4px","cursor":"pointer","width":"16px","height":"16px","flex-shrink":"0"}
        }, null, 512), [
          [_vModelCheckbox, _ctx.agreement]
        ]),
        _createElementVNode("span", _hoisted_6, [
          _createTextVNode(" Я ознакомился и согласен с "),
          _createVNode(_component_router_link, {
            to: "/privacy-policy",
            target: "_blank",
            style: {"text-decoration":"underline","color":"inherit"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Политикой конфиденциальности")
            ]),
            _: 1
          }),
          _createTextVNode(", а также даю согласие на обработку персональных данных ")
        ])
      ]),
      _createVNode(_component_AppButton, {
        theme: "dark",
        onClick: _ctx.submitRequest,
        disabled: !_ctx.agreement
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Отправить заявку ")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}